import gql from "graphql-tag";

export const UPDATE_RECEIPT_INFO = gql`
    mutation updateReceiptInfo($receiptInfo: String, $organizationId: ID) {
        updateReceiptInfo(
            receiptInfo: $receiptInfo
            organizationId: $organizationId
        ) {
            ok
            error
        }
    }
`;
